class SignInPresenter {
  constructor(view, signInUseCase) {
    this.view = view;
    this.signInUseCase = signInUseCase;
    this.change = {};
  }

  onChange(value, field) {
    this.change[field] = value;
  }

  async submit() {
    try {
      const user = {
        ...this.change,
      };
      this.view.showProgress();
      const signedInUser = await this.signInUseCase.execute(user);
      const roles = signedInUser.roles;
      const isAdmin = roles.some((role) => role.id === "Admin");

      if (isAdmin) {
        this.view.navigateTo("/clients");
      } else {
        this.view.navigateTo("/");
      }

      this.view.reload();
    } catch (error) {
      this.view.hideProgress();
      const errorMessage =
        error?.message ||
        error?.response?.data?.message ||
        (typeof error === "string"
          ? error
          : "Invalid credentials. Please try again.");
      this.view.setError(errorMessage);
      this.view.showError(error);
    }
  }
}

export default SignInPresenter;
